export const globalClasses = {
  scrollbarCustom: "scrollbar-custom",
  scrollbarYellow: "scrollbar-yellow",
  fullScreenBg: "full-screen-bg",
  loadBlur: "load-blur",
  noScroll: "no-scroll",
  fontConsolas: "font-consolas",
  centuryGothic: "century-gothic",
  datepickerFilled: "datepicker-filled",
  datepickerEmpty: "datepicker-empty",
  datepickerCalendar: "datepicker-calendar",
  animateLoading: "animate-loading",
  storesTable: "stores-table"
} as const;

export const layoutClasses = {
  pageContainer: "min-h-[calc(100vh-98px)] w-full mx-auto flex flex-col gap-4",
  contentWrapper: "",
  pageHeader: "flex justify-between flex-wrap md:flex-nowrap items-center mb-4",
  filtersContainer: "mb-1 flex flex-col md:flex-row items-start md:items-center justify-between w-full gap-3",
  actionsContainer: "flex flex-col xl:flex-row flex-wrap justify-end gap-2 items-center",
  tableContainer: "w-full max-w-full transition-all duration-300 pt-2 mt-2",
  tableWrapper: "",
  blurredContent: "blur-[5px]"
} as const;


export const buttonClasses = {
  linkButton: "flex items-center gap-1 text-[#3c7dd9] text-sm font-normal cursor-pointer hover:underline transition-all duration-200",
  linkButtonDisabled: "opacity-60 pointer-events-none",
  linkButtonEnabled: "opacity-100 pointer-events-auto",

  primaryButton: "px-4 py-3 bg-yellow-300 border border-gray-300 text-[#2b0c1a] text-base leading-5 font-medium rounded-md hover:underline hover:bg-yellow-400 transition-colors duration-200",

  buttonIcon: "text-xl",
  buttonIconSmall: "w-5 h-5"
} as const;
